'use client'

import classNames from 'classnames'
import { Footer } from '@biolumina/ui/components/footer/footer'
import { Header } from '@biolumina/ui/components/header/header'
import { PageBanner } from '@biolumina/ui/containers/pageBanner/pageBanner'
import { usePageData } from '@biolumina/ui/hooks/pageData.hook'
import { Box } from '@mui/material'
import { StyledPageLayout } from './pageLayout.styles'
import { useScrollspy } from '@biolumina/ui/hooks/scrollSpy.hook'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

export const PageLayout = ({
  children,
  refs,
  renderIsi = true,
  renderPageNav = true,
  hero,
  curved,
  wrapperComponent,
  ...props
}) => {
  const {
    display = null,
    pageDisplay = null,
    anchors,
    banner,
    isi,
    pageNav,
    showGreenBar,
    showIndication = true,
    bannerMode = 'default',
  } = usePageData()
  const pathname = usePathname()
  const pageNavigation = pageNav !== undefined ? pageNav : renderPageNav
  const pageIsi = isi !== undefined ? isi : renderIsi

  useScrollspy(anchors)
  const Wrapper = wrapperComponent || ContentWrapper

  useEffect(() => {
    const target = window.location.hash
    if (!target) return

    setTimeout(() => {
      document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' })
    }, 1)
  }, [pathname])

  return (
    <StyledPageLayout className="page-wrapper" {...props}>
      <Header />
      {showGreenBar && (
        <Box
          sx={{
            height: '60px',
            width: '100vw',
            bgcolor: '#79b93e',
            position: 'relative',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: 0,
            display: { xs: 'none', md: 'block' },
          }}
        />
      )}
      {hero}
      {banner && (
        <PageBanner mode={bannerMode} sx={{}}>
          {pageDisplay ?? display}
        </PageBanner>
      )}

      {children && <Wrapper>{children}</Wrapper>}
      <Footer
        renderNav={pageNavigation}
        refs={refs}
        renderIsi={pageIsi}
        showIndication={showIndication}
      />
    </StyledPageLayout>
  )
}

const ContentWrapper = ({ children, className = 'curved' }) => {
  return (
    <Box component="main" className={classNames('content-wrapper wide content', className)}>
      <Box className="content-wrapper">{children}</Box>
    </Box>
  )
}
